
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 52.5 56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M24.5 56H7a7.008 7.008 0 01-7-7 1.75 1.75 0 013.5 0A3.5 3.5 0 007 52.5h17.5a1.75 1.75 0 010 3.5z"}}),_c('path',{staticClass:"a",attrs:{"d":"M1.75 50.75A1.75 1.75 0 010 49V8.75A8.76 8.76 0 018.75 0H42a3.5 3.5 0 013.5 3.5v15.75a1.75 1.75 0 01-3.5 0V3.5H8.75A5.256 5.256 0 003.5 8.75v34.189A6.959 6.959 0 017 42h8.75a1.75 1.75 0 010 3.5H7A3.5 3.5 0 003.5 49a1.75 1.75 0 01-1.75 1.75z"}}),_c('path',{staticClass:"a",attrs:{"d":"M33.25 50.75a14 14 0 1114-14 14.015 14.015 0 01-14 14zm0-24.5a10.5 10.5 0 1010.5 10.5 10.512 10.512 0 00-10.5-10.5z"}}),_c('path',{staticClass:"a",attrs:{"d":"M50.75 56a1.741 1.741 0 01-1.237-.513l-8.839-8.839a1.75 1.75 0 012.476-2.474l8.839 8.839A1.75 1.75 0 0150.75 56z"}})])
          )
        }
      }
    